import type { NavRoutesConfig } from "#app/_ui/components/headers/nav-routes-config";

import filterHelper from "./filterHelper";
import type { NavRoutesConfigFilterParams } from "./filterNav";

export default function impersonationFilter({
  jwt,
  navRoutesConfig,
}: NavRoutesConfigFilterParams): NavRoutesConfig {
  let filtering = filterHelper(navRoutesConfig);

  if (jwt.isImpersonated) {
    filtering = filtering.removeRouteSubById(
      "ThreeSixtyWealthAndPlanning",
      "ThreeSixtyWealthTransactions",
    );
  }

  return filtering.getFilteredRoutesConfig();
}
